import type { Permission } from '@taim/shared';
import type { ReactNode } from 'react';
import { useAuth } from '@/lib/auth';
import { Page } from './PageHeader';

export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { can } = useAuth();
  if (!can(permission)) {
    return (
      <Page>
        <p className="text-muted-foreground">You don't have access to this page.</p>
      </Page>
    );
  }
  return <>{children}</>;
}
